import {
	Icons,
	Inline,
	Stack,
	Text,
	useBreakpoints,
} from "@sembark-travel/ui/base"
import { GetFieldValue, TextInputField } from "@sembark-travel/ui/form"
import { IChangePasswordCredentials } from "../Settings/ChangePassword"

type propsTypeOfNewAndConfirmPasswordFields = {
	newLabel: string
	conLabel: string
}

export function PasswordValidationCheckInfo({
	password,
}: {
	password: string | undefined
}) {
	return (
		<>
			<Inline alignItems={"center"} gap="1">
				{password && /[A-Z]/.test(password) ? (
					<Icons.OkCircleSolid size={"4"} color="success" />
				) : (
					<Icons.CancelCircleSolid size={"4"} opacity="50" color="danger" />
				)}
				<Text as="span" fontSize="sm">
					Minimum one uppercase
				</Text>
			</Inline>
			<Inline alignItems={"center"} gap="1">
				{password && /[a-z]/.test(password) ? (
					<Icons.OkCircleSolid size={"4"} color="success" />
				) : (
					<Icons.CancelCircleSolid opacity="50" size={"4"} color="danger" />
				)}
				<Text as="span" fontSize="sm">
					Minimum one lowercase
				</Text>
			</Inline>

			<Inline alignItems={"center"} gap="1">
				{password && /[0-9]/.test(password) ? (
					<Icons.OkCircleSolid size={"4"} color="success" />
				) : (
					<Icons.CancelCircleSolid opacity="50" size={"4"} color="danger" />
				)}
				<Text as="span" fontSize="sm">
					Minimum one number
				</Text>
			</Inline>
			<Inline alignItems={"center"} gap="1">
				{password && /[!@#$%^&*(),.?":{}|<>]/.test(password) ? (
					<Icons.OkCircleSolid size={"4"} color="success" />
				) : (
					<Icons.CancelCircleSolid opacity="50" size={"4"} color="danger" />
				)}
				<Text as="span" fontSize="sm">
					Minimum one special character (eg. !,@)
				</Text>
			</Inline>
			<Inline alignItems={"center"} gap="1">
				{password && password.length > 8 && password.length <= 15 ? (
					<Icons.OkCircleSolid size={"4"} color="success" />
				) : (
					<Icons.CancelCircleSolid opacity="50" size={"4"} color="danger" />
				)}
				<Text as="span" fontSize="sm">
					8 to 15 characters long
				</Text>
			</Inline>
		</>
	)
}

export function NewAndConfirmPasswordFields({
	newLabel,
	conLabel,
}: propsTypeOfNewAndConfirmPasswordFields) {
	const { xs } = useBreakpoints()
	return (
		<Inline gap={"2"} justifyContent={"between"}>
			<Stack flex={"1"} gap={"6"}>
				<Stack gap={"1"}>
					<TextInputField
						name="password"
						label={newLabel}
						type="password"
						required
						id="password"
						autoComplete="new-password"
					/>
					{xs && (
						<Stack>
							<Inline>
								<Text as="span" fontSize="sm">
									Password should be
								</Text>
							</Inline>
							<GetFieldValue<
								IChangePasswordCredentials["password"]
							> name="password">
								{({ value }) => (
									<PasswordValidationCheckInfo password={value} />
								)}
							</GetFieldValue>
						</Stack>
					)}
				</Stack>

				<TextInputField
					label={conLabel}
					name="password_confirmation"
					type="password"
					required
					id="password_confirmation"
					autoComplete="new-password"
				/>
			</Stack>
			{!xs && (
				<Stack>
					<Inline>
						<Text as="span" fontSize="sm">
							Password should be
						</Text>
					</Inline>
					<GetFieldValue<
						IChangePasswordCredentials["password"]
					> name="password">
						{({ value }) => <PasswordValidationCheckInfo password={value} />}
					</GetFieldValue>
				</Stack>
			)}
		</Inline>
	)
}
